import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SportsFullDetailPage } from './sports-full-detail';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    SportsFullDetailPage,
  ],
  imports: [
    IonicPageModule.forChild(SportsFullDetailPage),
    SharedModule
  ],
})
export class SportsFullDetailPageModule {}



// WEBPACK FOOTER //
// ./src/app/sports/sports-full-detail/sports-full-detail.module.ts